module.exports = __webpack_public_path__ + "static/consulting-e3089b3aa7a2cd444b6d01d9a46fef67.png";